// Provedores de LLM disponíveis
export const AVAILABLE_LLM_PROVIDERS = [
  {
    name: "OpenAI",
    value: "openai",
    logo: "/media/llmprovider/openai.png",
    description: "A opção padrão para a maioria dos casos de usos.",
    requiredConfig: ["OpenAiKey", "OpenAiModelPref"],
  },
  {
    name: "AWS Bedrock",
    value: "bedrock",
    logo: "/media/llmprovider/bedrock.png",
    description: "Execute modelos de fundo poderosos de forma privada com AWS Bedrock.",
    requiredConfig: [
      "AwsBedrockLLMAccessKeyId",
      "AwsBedrockLLMAccessKey",
      "AwsBedrockLLMRegion",
      "AwsBedrockLLMModel",
      "AwsBedrockLLMTokenLimit",
      "AwsBedrockLLMMaxOutputTokens",
    ],
  },
  {
    name: "Groq",
    value: "groq",
    logo: "/media/llmprovider/groq.png",
    description: "A inferência de LLM mais rápida disponível para aplicações de IA em tempo real.",
    requiredConfig: ["GroqApiKey", "GroqModelPref"],
  },
];

// Provedores de Embedding disponíveis
export const AVAILABLE_EMBEDDING_PROVIDERS = [
  {
    name: "OpenAI",
    value: "openai",
    logo: "/media/llmprovider/openai.png",
    description: "Modelos de embedding de alta qualidade da OpenAI.",
    requiredConfig: ["OpenAiKey"],
  },
  {
    name: "AWS Bedrock",
    value: "bedrock",
    logo: "/media/llmprovider/bedrock.png",
    description: "Modelos de embedding hospedados na AWS.",
    requiredConfig: [
      "AwsBedrockLLMAccessKeyId",
      "AwsBedrockLLMAccessKey",
      "AwsBedrockLLMRegion",
    ],
  },
  {
    name: "Cohere",
    value: "cohere",
    logo: "/media/llmprovider/cohere.png",
    description: "Modelos especializados de embedding da Cohere.",
    requiredConfig: ["CohereApiKey"],
  },
];

// Provedores de Banco Vetorial disponíveis
export const AVAILABLE_VECTOR_DB_PROVIDERS = [
  {
    name: "PostgreSQL",
    value: "postgresql",
    logo: "/media/vectordbs/pgvector.png",
    description: "Banco de dados vetorial usando PostgreSQL com extensão pgvector.",
    requiredConfig: [
      "PostgresqlHost",
      "PostgresqlPort",
      "PostgresqlDatabase",
      "PostgresqlUsername",
      "PostgresqlPassword",
    ],
  },
  {
    name: "LanceDB",
    value: "lancedb",
    logo: "/media/vectordbs/lancedb.png",
    description: "Banco de dados vetorial embutido e de alto desempenho.",
    requiredConfig: [],
  },
  {
    name: "Pinecone",
    value: "pinecone",
    logo: "/media/vectordbs/pinecone.png",
    description: "Banco de dados vetorial gerenciado na nuvem.",
    requiredConfig: ["PineconeApiKey", "PineconeEnvironment"],
  },
  {
    name: "Qdrant",
    value: "qdrant",
    logo: "/media/vectordbs/qdrant.png",
    description: "Banco de dados vetorial de código aberto e alto desempenho.",
    requiredConfig: ["QdrantUrl", "QdrantApiKey"],
  },
  {
    name: "Chroma",
    value: "chroma",
    logo: "/media/vectordbs/chroma.png",
    description: "Banco de dados vetorial de código aberto para aplicações de IA.",
    requiredConfig: ["ChromaUrl"],
  },
  {
    name: "Weaviate",
    value: "weaviate",
    logo: "/media/vectordbs/weaviate.png",
    description: "Banco de dados vetorial com recursos de IA nativos.",
    requiredConfig: ["WeaviateUrl", "WeaviateApiKey"],
  },
];
